module.exports = __webpack_public_path__ + "media/images/favicon/secondary/android-icon-48x48-e78651c2187dbe3013eb3413fc92e7f6.png";